import Button from '../../Atoms/Button';
import Title from '../../Atoms/Title';

function PageNotFound() {
  return (
    <div className="flex flex-col items-center gap-5 py-28 px-7">
      <span className="text-center text-[150px] font-bold leading-[90px] text-sl-blue md:text-[200px] md:leading-[110px]">
        404
      </span>
      <Title as="h1" size={2} className="text-center">
        Pagina niet gevonden
      </Title>
      <Button
        as="a"
        href="/"
        color="primary"
        text="Naar de homepage"
      />
    </div>
  );
}

export default PageNotFound;
